import React from 'react';
import DocLink from './DocLink.js';

export default (props) => {
    return (
        <div>
          <p>
            The <b>Convolver Reverb</b> effect uses an <b>Impulse Response</b> sample to create
            a reverb that mimics the acoustics and textures of that sample. 
          </p>
          <p>
            The most common use of this is modeling a physical room, such as a cave. However, you
            can drag any sample into the <b>Convolver Reverb</b> effect. To do so, just drag the thumbnail
            for a sample-- either from the track or the sound selector sidebar-- into the Convolver's
            effect box.
          </p>
          <p>
            The <b>Convolver Reverb</b> has parameters for controlling the <b>pitch</b>, <b>attack</b> and <b>release</b> of the<b>Impulse Response</b> sample.
            These-- especially pitch-- have huge implications for the sound of the effect. 
          </p>
          <p>
            Droning samples that sustain work very well as <b>Impulse Response</b> samples, creating
            rich, acoustic timbres from your sounds. 
          </p>
        </div>
    );
};
